/**
 * @class
 * @description Wrapper class that injects our modified shaka loader in a ShakaPlayer instance.
 * @exports Shaka
 */
export default class Shaka {
    /**
     * Constructs Shaka adapter.
     * @param {Object} shakaObject Shaka constructor object reference, window.shaka by default.
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(shakaObject = window['shaka']) {
        this._loader = new (Shaka._adapters.getLoaders().LoaderShaka)(shakaObject);
    }
    /**
     * Method to disable the SDK capability to intercept shaka requests.
     * Use it if you want to play a video without balancing or P2P.
     * @public
     */
    disable() {
        this._loader.unregister();
    }
    /**
     * Method to re-enable the SDK capability to intercept shaka requests.
     * Use it if you want to play a video with balancing or P2P and you called disable() before.
     * @public
     */
    enable() {
        this._loader.register();
    }
}
